import { matchesPathname } from "@/lib/pathname";

const NOTIFICATION_SUPPRESSED_PATHS = [
  "/login",
  "/logout",
  "/onboarding",
] as const;

export function shouldEnableNotifications({
  pathname,
  userType,
}: {
  pathname?: string | null;
  userType?: string;
}): boolean {
  const isEligibleUser = userType === "employee" || userType === "employer";
  const isSuppressedRoute = NOTIFICATION_SUPPRESSED_PATHS.some((route) =>
    matchesPathname(pathname ?? "", route)
  );

  return isEligibleUser && !isSuppressedRoute;
}
